{
  "title": "Patients",
  "description": "Gérez vos patients et leurs informations",
  "addPatient": "Ajouter un Patient",
  "search": {
    "placeholder": "Rechercher des patients...",
    "noResults": "Aucun patient trouvé",
    "tryDifferent": "Essayez un terme de recherche différent"
  },
  "empty": {
    "title": "Aucun patient pour le moment",
    "description": "Commencez par ajouter votre premier patient pour gérer leurs soins",
    "addFirst": "Ajouter le Premier Patient"
  },
  "list": {
    "title": "Vos Patients",
    "description": "Vous avez {{count}} patient(s) au total"
  },
  "table": {
    "patient": "Patient",
    "email": "Email",
    "phone": "Téléphone",
    "createdAt": "Ajouté",
    "actions": "Actions",
    "view": "Voir",
    "gender": {
      "man": "Homme",
      "woman": "Femme",
      "other": "Autre"
    }
  },
  "create": {
    "title": "Ajouter un Nouveau Patient",
    "description": "Entrez les informations du patient pour l'ajouter à votre pratique",
    "fields": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "birthDate": "Date de Naissance",
      "selectBirthDate": "Sélectionner la date de naissance",
      "gender": "Genre",
      "selectGender": "Sélectionner le genre",
      "genderOptions": {
        "man": "Homme",
        "woman": "Femme",
        "other": "Autre"
      }
    },
    "cancel": "Annuler",
    "create": "Ajouter le Patient",
    "creating": "Ajout en cours..."
  },
  "edit": {
    "title": "Modifier le Patient",
    "description": "Mettre à jour les informations de {{name}}",
    "fields": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "birthDate": "Date de Naissance",
      "gender": "Genre",
      "selectGender": "Sélectionner le genre",
      "genderOptions": {
        "man": "Homme",
        "woman": "Femme",
        "other": "Autre"
      }
    },
    "cancel": "Annuler",
    "update": "Mettre à Jour le Patient",
    "updating": "Mise à jour..."
  },
  "details": {
    "title": "Détails du Patient",
    "description": "Voir et gérer les informations du patient",
    "back": "Retour aux Patients",
    "edit": "Modifier le Patient",
    "notFound": "Patient non trouvé",
    "notFoundDescription": "Le patient que vous recherchez n'existe pas ou a été supprimé",
    "backToPatients": "Retour aux Patients",
    "patientInfo": "Informations du Patient",
    "patientData": "Données du Patient",
    "patientDataDescription": "Voir les évaluations, notes et autres données du patient",
    "yearsOld": "ans",
    "createdOn": "Patient depuis",
    "gender": {
      "man": "Homme",
      "woman": "Femme",
      "other": "Autre"
    },
    "tabs": {
      "overview": "Aperçu",
      "evaluations": "Évaluations",
      "notes": "Notes",
      "anamnesis": "Anamnèse"
    },
    "overview": {
      "personalInfo": "Informations Personnelles",
      "accountInfo": "Informations du Compte",
      "fullName": "Nom Complet",
      "email": "Email",
      "phone": "Téléphone",
      "gender": "Genre",
      "birthDate": "Date de Naissance",
      "patientId": "ID Patient",
      "createdAt": "Créé",
      "lastUpdated": "Dernière Mise à Jour",
      "notProvided": "Non fourni"
    },
    "evaluations": {
      "title": "Évaluations du Patient",
      "count": "{{count}} évaluation(s)",
      "noEvaluations": "Aucune évaluation pour le moment",
      "noEvaluationsDescription": "Ce patient n'a pas encore d'évaluation. Les évaluations se créent depuis l'application mobile MetaDevProfile.",
      "evaluationType": "Évaluation",
      "view": "Voir les Détails",
      "status": "Statut",
      "duration": "Durée",
      "durationValue": "{{duration}}min",
      "notCompleted": "Non terminé"
    },
    "notes": {
      "title": "Notes du Patient",
      "noNotes": "Aucune note pour le moment",
      "noNotesDescription": "Ajoutez des notes sur ce patient pour garder une trace des informations importantes",
      "addFirst": "Ajouter la Première Note",
      "addNote": "Ajouter une Note",
      "newNote": "Nouvelle Note",
      "newNoteDescription": "Ajouter une note sur ce patient",
      "placeholder": "Entrez votre note ici...",
      "save": "Sauvegarder la Note",
      "cancel": "Annuler"
    },
    "anamnesis": {
      "title": "Anamnèse Médicale",
      "noAnamnesis": "Aucune donnée d'anamnèse disponible",
      "noAnamnesisDescription": "L'historique médical et l'anamnèse apparaîtront ici une fois collectés",
      "medicalHistory": "Historique Médical",
      "medicalHistoryDescription": "Antécédents médicaux du patient et informations de santé pertinentes",
      "comingSoon": "Fonctionnalité d'anamnèse bientôt disponible",
      "noData": "Aucune donnée d'anamnèse disponible pour ce patient",
      "noQuestions": "Aucune question dans cette section",
      "noItems": "Aucun élément dans cette section",
      "noAnswer": "Aucune réponse fournie"
    }
  },
  "success": {
    "createPatientSuccess": "Patient créé avec succès",
    "updatePatientSuccess": "Patient mis à jour avec succès"
  },
  "errors": {
    "createPatientFailed": "Échec de la création du patient",
    "deletePatientFailed": "Échec de la suppression du patient",
    "loadPatientFailed": "Échec du chargement du patient",
    "loadPatientsFailed": "Échec du chargement des patients",
    "updatePatientFailed": "Échec de la mise à jour du patient",
    "loadAnamnesisFailed": "Échec du chargement de l'anamnèse"
  }
}
